import { render, staticRenderFns } from "./PromotionFlow.vue?vue&type=template&id=36b9c97e&scoped=true"
import script from "./PromotionFlow.vue?vue&type=script&lang=js"
export * from "./PromotionFlow.vue?vue&type=script&lang=js"
import style0 from "./PromotionFlow.vue?vue&type=style&index=0&id=36b9c97e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36b9c97e",
  null
  
)

export default component.exports